// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__settings--yHJoo {
  width: 100%;
  height: 100%;
}
.style__settingsTabs--vQK3v {
  display: flex;
  justify-content: space-between;
}
.style__settingsRow--QUHWO {
  align-items: center;
  display: flex;
  margin-top: 2rem;
  width: 100%;
  gap: 2rem;
  justify-content: space-between;
}
.style__settingsSecondRow--EtZ8R {
  display: flex;
  gap: 2rem;
  width: 60%;
}
.style__settingsSecondRow--EtZ8R > div > div > div {
  display: flex;
}
.style__preferences--jEzwg {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.style__teamTab--JH_0u {
  height: calc(100% - 6rem);
}
.style__inputFieldBox--x0Q33 {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  color: #7d8287;
  font-size: 12px;
}
.style__inputField--DvKlA {
  color: #7d8287 !important;
  height: 3rem;
  border-radius: 0.5rem !important;
}
.style__inputField--DvKlA > p {
  margin-top: 0 !important;
}
.style__inputFieldMenu--Ey2ls {
  min-width: 150px !important;
}
.style__inputFieldMenu--Ey2ls li {
  height: 2.5rem;
}
.style__languageItem--klLne {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}
.style__languageItem--klLne > svg {
  transform: scale(0.833);
}
.style__iconSelect--W2tEO {
  margin-right: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SettingsPage/style.less"],"names":[],"mappings":"AAGA;EAEI,WAAA;EACA,YAAA;AAHJ;AAAA;EAOI,aAAA;EACA,8BAAA;AAJJ;AAJA;EAYI,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,8BAAA;AALJ;AAZA;EAqBI,aAAA;EACA,SAAA;EACA,UAAA;AANJ;AAjBA;EA0BM,aAAA;AANN;AApBA;EA+BI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AARJ;AA1BA;EAsCI,yBAAA;AATJ;AA7BA;EA0CI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAVJ;AApCA;EAkDI,yBAAA;EACA,YAAA;EACA,gCAAA;AAXJ;AAzCA;EAuDM,wBAAA;AAXN;AA5CA;EA4DI,2BAAA;AAbJ;AA/CA;EA8DM,cAAA;AAZN;AAlDA;EAmEI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAdJ;AAxDA;EAyEM,uBAAA;AAdN;AA3DA;EA8EI,kBAAA;AAhBJ","sourcesContent":["@import '@yaak/components/src/colors';\n@import '@yaak/components/src/spacing';\n\n:local {\n  .settings {\n    width: 100%;\n    height: 100%;\n  }\n\n  .settingsTabs {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .settingsRow {\n    align-items: center;\n    display: flex;\n    margin-top: @spacing-200;\n    width: 100%;\n    gap: @spacing-200;\n    justify-content: space-between;\n  }\n\n  .settingsSecondRow {\n    display: flex;\n    gap: @spacing-200;\n    width: 60%;\n\n    > div > div > div {\n      display: flex;\n    }\n  }\n\n  .preferences {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .teamTab {\n    height: calc(100% - 6rem);\n  }\n\n  .inputFieldBox {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-25;\n    color: @color-asphalt-grey-050;\n    font-size: 12px;\n  }\n\n  .inputField {\n    color: @color-asphalt-grey-050 !important;\n    height: @spacing-300;\n    border-radius: @spacing-50 !important;\n\n    > p {\n      margin-top: 0 !important;\n    }\n  }\n\n  .inputFieldMenu {\n    min-width: 150px !important;\n    li {\n      height: @spacing-250;\n    }\n  }\n\n  .languageItem {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: @spacing-75;\n\n    > svg {\n      transform: scale(0.833);\n    }\n  }\n\n  .iconSelect {\n    margin-right: @spacing-100;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settings": `style__settings--yHJoo`,
	"settingsTabs": `style__settingsTabs--vQK3v`,
	"settingsRow": `style__settingsRow--QUHWO`,
	"settingsSecondRow": `style__settingsSecondRow--EtZ8R`,
	"preferences": `style__preferences--jEzwg`,
	"teamTab": `style__teamTab--JH_0u`,
	"inputFieldBox": `style__inputFieldBox--x0Q33`,
	"inputField": `style__inputField--DvKlA`,
	"inputFieldMenu": `style__inputFieldMenu--Ey2ls`,
	"languageItem": `style__languageItem--klLne`,
	"iconSelect": `style__iconSelect--W2tEO`
};
export default ___CSS_LOADER_EXPORT___;
